import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthService } from './pages/authmanagement/services/Auth.service';
import { SessionService } from './shared/services/Session.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { environment } from "src/environments/environment";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit {
  constructor(
    private authService: AuthService, 
    private router: Router, 
    private activatedRoute: ActivatedRoute, 
    private sessionService: SessionService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) {
    this.IsAuthenticated = false;
    
    this.iconRegistry.addSvgIcon(
      'custom_calendar',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/img/icon_calendario.svg')
    );
  }
  public IsAuthenticated: boolean;
  title = "app";
  rutaActual: string;
  isNavVisible: boolean = false;

  ngOnInit() {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&libraries=places`;
    script.async = true;
    document.head.appendChild(script);

    this.CheckRoute();
  }
  CheckAuthentication() {
    if (!(this.rutaActual === '/' || this.rutaActual === '/home' || this.rutaActual === '/login' || this.rutaActual === '/callback' || this.rutaActual === '/error' || this.rutaActual.includes('/recoveryPassword'))) {
      this.IsAuthenticated = this.authService.isAuthenticated;
      if(!environment.production) console.log("Authenticated:" + this.IsAuthenticated);
    }
  }

  CheckRoute(){
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if(!environment.production) console.log(event.url);
        this.rutaActual = event.urlAfterRedirects;
        this.CheckAuthentication();
        if (this.rutaActual === '/' || this.rutaActual === '/login' || this.rutaActual === '/home' || this.rutaActual === '/callback' || this.rutaActual === '/error' || this.rutaActual == undefined || this.rutaActual.includes('/recoveryPassword')) {
          this.isNavVisible = false;
        } else {
          this.isNavVisible = true;
        }
      }
    });
  }
  
}

  

